module.exports = __webpack_public_path__ + "img/heroes-of-wakanda.98e30ec6.svg";